import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import ModalContainer from 'components/ModalContainer'
import PopoverContent from 'components/PopoverContent'
import { buildTranslate } from 'locales'
import { Fields as Product } from 'models/Product'
import React from 'react'
import { currencyFormatter } from 'utilities/formatters'

const t = buildTranslate('redeem_manager.product_select')

type ProductModalProps = {
  isOpen: boolean
  onClose: () => void
  product: Product
}

const getBreadcrumb = (product: Product): string | null => {
  const menuName = product.menu ? product.menu.name || product.menu.uid : null
  const categoryName = product.category?.name ?? null

  if (menuName && categoryName) return `${menuName} > ${categoryName}`
  if (!menuName && categoryName)
    return `${t('default_menu_name')} > ${categoryName}`
  if (menuName && !categoryName) return menuName
  return null
}

const ProductModal: React.FC<ProductModalProps> = ({
  isOpen,
  onClose,
  product,
}) => {
  const breadcrumb = getBreadcrumb(product)

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      showBottomProceed={false}
      hideCancel
      title={product.name}
    >
      <div className="d-flex flex-column">
        <Switch condition={breadcrumb !== null}>
          <Text.BodyText4 color="grey50" className="mb-s">
            {breadcrumb}
          </Text.BodyText4>
        </Switch>

        <Text.BodyText4 color="grey70" className="mb-s">
          {t('learn_more_about_item')}
        </Text.BodyText4>

        <Text.BodyText4 color="grey50" className="mb-xs uppercase">
          <span className="mr-xs">{t('guid')}</span>
          <PopoverContent sections={[{ content: t('guid_info') }]} />
        </Text.BodyText4>
        <Text.BodyText4 color="grey70" className="mb-s">
          {product.chain_uid}
        </Text.BodyText4>

        <Text.BodyText4 color="grey50" className="mb-xs uppercase">
          {t('price')}
        </Text.BodyText4>
        <Text.BodyText4 color="grey70" className="mb-s">
          {currencyFormatter(product.price)}
        </Text.BodyText4>
      </div>
    </ModalContainer>
  )
}

export default ProductModal
